import { render, staticRenderFns } from "./AdminCourseTemplatesPopup.vue?vue&type=template&id=45a2965b&scoped=true&"
import script from "./AdminCourseTemplatesPopup.vue?vue&type=script&lang=js&"
export * from "./AdminCourseTemplatesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2965b",
  null
  
)

export default component.exports